module.exports = __webpack_public_path__ + "static/media/game-icon.e1c9b6a0.png";